import { render } from "./InvitePatientModal.vue?vue&type=template&id=396e10fa&ts=true"
import script from "./InvitePatientModal.vue?vue&type=script&lang=ts"
export * from "./InvitePatientModal.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__